import makeStyles from '@material-ui/core/styles/makeStyles'
import { createStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: 40,
      position: 'absolute',
      width: 600,
      height: 300,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      outline: 0,
      boxShadow: theme.shadows[5],
    },
    modal: {
      padding: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
)
